export default __webpack_public_path__ + "static/media/pokemon-placeholder.4a57c616.png";